export default `float de(vec3 p){
    float a=1.;
    for(int i=0;i<5;i++){ 
      p=abs(p)-1./3.;
      if(p.y>p.x)p.xy=p.yx;
      if(p.z>p.y)p.yz=p.zy;
      p.z=abs(p.z);
      p*=3.;
      p-=1.;
      a*=3.;
    }
    return length(max(abs(p)-1.,0.))/a;
  }`